import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { aboutContent } from '../pages/about.js';

const AboutPage = () => {
  const location = useLocation();

  // Handle hash navigation
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="page-container">
      <div className="page-content">
        <div dangerouslySetInnerHTML={{ __html: aboutContent }} />
      </div>
    </div>
  );
};

export default AboutPage;
